/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Flex, Input, Menu, MenuList, Spinner, Table, TableContainer, Tbody, Text, Thead, useToast } from '@chakra-ui/react'
import { PDFDownloadLink } from '@react-pdf/renderer'
import 'pdfjs-dist/build/pdf.worker.entry'
import React, { useEffect, useState } from 'react'
import { BsCoin } from 'react-icons/bs'
import { FaChevronDown, FaDownload, FaExclamationCircle, FaFilePdf } from 'react-icons/fa'
import { FaPeopleGroup } from 'react-icons/fa6'
import { MdOutlineBusinessCenter } from 'react-icons/md'
import { pdfjs } from 'react-pdf'
import { useNavigate } from 'react-router-dom'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import LoadingContainer from '../../../../components/LoadingContainer'
import { MenuButtonCmp } from '../../../../components/MenuButtonCmp'
import { ModalDelete } from '../../../../components/ModalDelete'
import { StyledMenuItem } from '../../../../components/NavBar/Components/StyledMenuItem'
import { Paginador } from '../../../../components/Paginador'
import { SearchCmp } from '../../../../components/SearchCmp'
import { SelectCmp } from '../../../../components/SelectCmp'
import { appApi } from '../../../../services/appApi'
import { parseJwt } from '../../../../services/token'
import { AutorizarConsultorPrismah, AutorizarReprocessarPrismah } from '../../../../Utils/Helper'
import { Body } from '../../../Layouts/Body'
import { formatarData } from '../../components/TabelaPerfis'
import { BoxQtd } from './components/BoxQtd'
import { ModalProgresso } from './components/ModalProgresso'
import { ModalTabelaAderencia } from './components/ModalTabelaAderencia'
import { PieChart } from './components/PieChart'
import { RelatorioIndividualPDF } from './components/RelatorioIndividualPDF'
import { RelatorioPDF } from './components/RelatorioPDF'
import { iRelatorioIndividualSI, iRelatorioSI } from './interfaceRelatorioSI'
import { GetStatus, GetStatusTitulo, GetStatusVisiveis, StatusRevisaoAh, VerTodosStatus } from './statusAssessment'
import { StyledSpan, Td, Th, Tr } from './styles'

export interface itemGestao {
  id: string
  nome: string
  cpf: string
  email: string
  assessmentId: string
  linkedin: string
  gestor: string
  emailGestor: string
  nomeBP: string
  nomeCargo: string
  assessmentIdGestor: string
  urlRelatorioCandidato: string
  urlpiCandidato: string
  urlpiGestor: string
  urlCurriculo: string
  urlRelatorioGestor: string
  urlDescritivoCargo: string
  urlpiDesenvolvimento?: string
  dataCriacao?: string
  dataAlterado?: string
  urlpiRelacionamentoGestor?: string
  dadosGpt?: string
  status: number
  urlpdfRelatorioRH?: string
  urlpdfRelatorioIndividual?: string
  versaoPrismah?: string
  empresaId?: string
  nomeEmpresa?: string
}

interface iResponseAssessments {
  total: number
  pendentesRevisao: number
  itens: itemGestao[]
}

const ChaveFiltros = 'filtrosGestaoPrismah'

interface iFiltrosSalvos {
  status?: string
  dataInicio?: string
  dataFim?: string
  empresa?: string
  pagina?: number
  tamanho?: number
}

function LerFiltrosSalvos(): iFiltrosSalvos {
  try {
    return JSON.parse(sessionStorage.getItem(ChaveFiltros) ?? '{}')
  } catch {
    return {}
  }
}

interface iEmpresaFiltro {
  empresaId: string
  nome: string
}

interface iDash {
  top10: iTop10[]
  nomeCargoUnicos: number
  totalRegistros: number
  tipoAcesso: number
  creditos: number
  aderentes: itemGestao[]
  aderentesResalva: itemGestao[]
  naoAderentes: itemGestao[]
  porAderencia5?: Record<string, itemGestao[]>
  statusAssessments: statusDash[]
}

const niveisPizza5 = [
  { nivel: 5, label: 'Altamente aderente', cor: '#18743B' },
  { nivel: 4, label: 'Aderente', cor: '#A3D943' },
  { nivel: 3, label: 'Aderente com ressalvas', cor: '#F2C94C' },
  { nivel: 2, label: 'Pouco aderente', cor: '#F2994A' },
  { nivel: 1, label: 'Não aderente', cor: '#D64545' }
]

interface statusDash {
  id: number
  quantidade: number
}

export interface iTop10 {
  nomeBp: string
  quantidade: number
}

export const DashboardSI: React.FC = () => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
  const toast = useToast()
  const nav = useNavigate()
  const [Dash, setDash] = useState<iDash>({ nomeCargoUnicos: 0, top10: [], totalRegistros: 0, statusAssessments: [], creditos: 0, tipoAcesso: 0, aderentes: [], aderentesResalva: [], naoAderentes: [] })
  const [IsLoading, setIsLoading] = useState<string>()
  const [ModalProgressoIsOpen, setModalProgressoIsOpen] = useState(false)
  const [Model, setModel] = useState<iRelatorioSI>()
  const [ModelIndividual, setModelIndividual] = useState<iRelatorioIndividualSI>()
  const [BaixarRelatorio, SetBaixarRelatorio] = useState(false)
  const [BaixarRelatorioIndividual, SetBaixarRelatorioIndividual] = useState(false)
  const [EscalaRelatorio, setEscalaRelatorio] = useState<3 | 5>(3)
  const [EscalaPizza, setEscalaPizza] = useState<3 | 5>(3)
  const [ItemAtivo, setItemAtivo] = useState<string>()
  const [ModalDeleteIsOpen, setModalDeleteIsOpen] = useState(false)
  const [ModalAderenciaIsOpen, setModalAderenciaIsOpen] = useState(false)
  const [Candidatos, setCandidatos] = useState<itemGestao[]>([])
  const [Titulo, setTitulo] = useState('')
  const token = parseJwt()
  function onGetModelRelatorio(id: string): void {
    setIsLoading(id)
    appApi.get(`api/SI/Relatorio/${id}`)
      .then((res) => setModel(res.data))
      .catch((err) => console.log(err))
  }

  function onChangeStatus(id: string, status: string): void {
    setIsLoadingBody(true)
    appApi.put(`api/SI/${id}/trocarStatus?statusNovo=${status}`)
      .then((res) => GetItems())
      .catch((err) => { console.log(err); setIsLoadingBody(false) })
  }

  function onGetModelIndividual(id: string): void {
    setIsLoading(id)
    appApi.get(`api/SI/Relatorio/${id}/Individual`)
      .then((res) => setModelIndividual(res.data))
      .catch((err) => console.log(err))
  }

  function OnOpenModal(titulo: string): void {
    setIsLoadingBody(true)
    setTimeout(() => {
      setModalAderenciaIsOpen(true)
      setTitulo(titulo)
      setIsLoadingBody(false)
    }, 300)
  }

  function onGetDash(): void {
    setIsLoadingBody(true)
    appApi.get('api/SI/Dashboard')
      .then((res) => setDash(res.data))
      .catch((err) => console.log(err))
      .finally(() => {
        setTimeout(() => {
          setIsLoadingBody(false)
        }, 400)
      })
  }

  const baixarRelatorio = async (model: itemGestao, linkUrl: string, posNomeArquivo: string) => {
    const response = await fetch(linkUrl)
    const blob = await response.blob()
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = `${model.nome.replaceAll(' ', '_')}_${posNomeArquivo}.pdf`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  function onPostRelatorio(base64: string, isIndividual: boolean, segundoRelatorio: boolean): void {
    appApi.post(`api/SI/${ItemAtivo}/uploadRelatorioPDF`, { pdf: base64, individual: isIndividual })
      .then(() => {
        if (segundoRelatorio) {
          GetItems(undefined, true)
          setIsLoading(undefined)
          setItemAtivo(undefined)
          SetBaixarRelatorioIndividual(false)
          SetBaixarRelatorio(false)
          setModalProgressoIsOpen(false)
        } else {
          SetBaixarRelatorio(true)
        }
      })
      .catch((err) => console.log(err))
  }

  useEffect(() => {
    if (BaixarRelatorio) {
      setTimeout(async () => {
        const botao: any = document.getElementById('botaoBaixarRelatorio')
        const response = await fetch(botao.href)
        const blob = await response.blob()
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onloadend = () => {
          const base64PDF = reader.result as string
          if (base64PDF.includes('html;base64')) {
            SetBaixarRelatorio(false)
            setTimeout(() => {
              SetBaixarRelatorio(true)
            }, 300)
          } else {
            onPostRelatorio(base64PDF, false, true)
          }
        }
        SetBaixarRelatorio(false)
      }, 3500)
    }
  }, [BaixarRelatorio])

  useEffect(() => {
    if (BaixarRelatorioIndividual) {
      setTimeout(async () => {
        const botao: any = document.getElementById('botaoBaixarRelatorioIndividual')
        const response = await fetch(botao.href)
        const blob = await response.blob()
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onloadend = () => {
          const base64PDF = reader.result as string
          if (base64PDF.includes('html;base64')) {
            SetBaixarRelatorioIndividual(false)
            setTimeout(() => {
              SetBaixarRelatorioIndividual(true)
            }, 300)
          } else {
            onPostRelatorio(base64PDF, true, false)
          }
        }
      }, 500)
    }
  }, [BaixarRelatorioIndividual])

  function OnClearRelatorios(): void {
    setModel(undefined)
    setModelIndividual(undefined)
    setItemAtivo(undefined)
    setModalProgressoIsOpen(false)
  }

  const [IsLoadingBody, setIsLoadingBody] = useState(false)
  const [SearchText, setSearchText] = useState('')
  const [BuscaAplicada, setBuscaAplicada] = useState('')
  const [Items, setItems] = useState<itemGestao[]>([])
  const [FiltrosSalvos] = useState(LerFiltrosSalvos)
  const [StatusFiltro, setStatusFiltro] = useState(FiltrosSalvos.status ?? '')
  const [DataInicioFiltro, setDataInicioFiltro] = useState(FiltrosSalvos.dataInicio ?? '')
  const [DataFimFiltro, setDataFimFiltro] = useState(FiltrosSalvos.dataFim ?? '')
  const [EmpresaFiltro, setEmpresaFiltro] = useState(FiltrosSalvos.empresa ?? '')
  const [Empresas, setEmpresas] = useState<iEmpresaFiltro[]>([])
  const [Pagina, setPagina] = useState(FiltrosSalvos.pagina ?? 0)
  const [Tamanho, setTamanho] = useState(FiltrosSalvos.tamanho ?? 50)
  const [Total, setTotal] = useState(0)
  const [PendentesRevisao, setPendentesRevisao] = useState(0)
  const tokenJwt = localStorage.getItem('token')
  // so quem enxerga todas as contas precisa da coluna de empresa
  const ExibirEmpresa = Dash.tipoAcesso === 1
  const PodeRevisar = Dash.tipoAcesso === 1 || AutorizarConsultorPrismah()
  const VerTodos = VerTodosStatus(Dash.tipoAcesso)
  function GetPermissaoBotoesClaro(): boolean {
    return Dash.tipoAcesso === 1 || Dash.tipoAcesso === 2
  }

  function OnChangeFiltroStatus(status: string): void {
    setStatusFiltro(status)
    setPagina(0)
  }

  function OnChangeFiltroData(dataInicio: string, dataFim: string): void {
    setDataInicioFiltro(dataInicio)
    setDataFimFiltro(dataFim)
    setPagina(0)
  }

  function OnChangeFiltroEmpresa(empresaId: string): void {
    setEmpresaFiltro(empresaId)
    setPagina(0)
  }

  function GetEmpresas(): void {
    appApi.get<iEmpresaFiltro[]>('api/SI/Empresas')
      .then((res) => setEmpresas(res.data))
      .catch((err) => console.log(err))
  }

  function GetItems(firstReq?: boolean, isRelatorio?: boolean): void {
    if (firstReq) setIsLoadingBody(true)
    appApi.get<iResponseAssessments>(`api/SI?pagina=${Pagina}&limite=${Tamanho}${StatusFiltro !== '' ? `&status=${StatusFiltro}` : ''}${DataInicioFiltro !== '' ? `&dataInicio=${DataInicioFiltro}` : ''}${DataFimFiltro !== '' ? `&dataFim=${DataFimFiltro}` : ''}${EmpresaFiltro !== '' ? `&empresaId=${EmpresaFiltro}` : ''}${BuscaAplicada !== '' ? `&busca=${encodeURIComponent(BuscaAplicada)}` : ''}`)
      .then((res) => {
        setItems(res.data.itens)
        setTotal(res.data.total)
        setPendentesRevisao(res.data.pendentesRevisao)
        if (isRelatorio) {
          toast({
            title: 'Relatórios gerados com sucesso!',
            status: 'success',
            duration: 4000,
            position: 'top'
          })
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoadingBody(false))
  }

  function DeleteItem(id: string): void {
    setIsLoadingBody(true)
    appApi.delete(`api/SI/${id}`)
      .then((res) => GetItems())
      .catch((err) => { console.log(err); setIsLoadingBody(false) })
  }

  function ReprocessarIA(id: string): void {
    setIsLoadingBody(true)
    appApi.post(`api/PrismahProcessador/EnviarProcessamentoGalaxy/${id}`)
      .then(() => {
        toast({
          title: 'Reprocessamento enviado com sucesso!',
          status: 'success',
          duration: 4000,
          position: 'top'
        })
        GetItems()
      })
      .catch((err) => {
        console.log(err)
        toast({
          title: 'Não foi possível reprocessar a IA.',
          status: 'error',
          duration: 4000,
          position: 'top'
        })
        setIsLoadingBody(false)
      })
  }

  function OnGerarRelatorios(id: string, escala: 3 | 5): void {
    setEscalaRelatorio(escala)
    setItemAtivo(id)
    onGetModelIndividual(id)
    onGetModelRelatorio(id)
  }

  useEffect(() => {
    if (ItemAtivo && IsLoading && ItemAtivo === IsLoading) {
      setModalProgressoIsOpen(true)
      SetBaixarRelatorioIndividual(true)
    }
  }, [Model, ModelIndividual])

  useEffect(() => {
    try {
      sessionStorage.setItem(ChaveFiltros, JSON.stringify({ status: StatusFiltro, dataInicio: DataInicioFiltro, dataFim: DataFimFiltro, empresa: EmpresaFiltro, pagina: Pagina, tamanho: Tamanho }))
    } catch {}
  }, [Pagina, Tamanho, StatusFiltro, DataInicioFiltro, DataFimFiltro, EmpresaFiltro])

  useEffect(() => {
    GetItems(true)
  }, [Pagina, Tamanho, StatusFiltro, DataInicioFiltro, DataFimFiltro, EmpresaFiltro, BuscaAplicada])

  useEffect(() => {
    const termo = SearchText.trim()
    if (termo === BuscaAplicada) return
    const timer = setTimeout(() => {
      setBuscaAplicada(termo)
      setPagina(0)
    }, 400)
    return () => clearTimeout(timer)
  }, [SearchText])

  useEffect(() => {
    onGetDash()
  }, [])

  useEffect(() => {
    if (ExibirEmpresa) GetEmpresas()
  }, [ExibirEmpresa])

  return (
    <Body isLoading={IsLoadingBody} style={ExibirEmpresa ? { width: 'min(100% - 2rem, 92rem)' } : undefined}>
      {ModalAderenciaIsOpen && <ModalTabelaAderencia
        IsLoading={IsLoading}
        baixarRelatorio={baixarRelatorio}
        candidatos={Candidatos}
        isOpen={ModalAderenciaIsOpen}
        onChangeStatus={onChangeStatus}
        onRequestClose={() => {
          setModalAderenciaIsOpen(false)
          setCandidatos([])
        }}
        tipoAcesso={Dash.tipoAcesso}
        titulo={Titulo}
      />}
      {ItemAtivo && <ModalDelete
        isOpen={ModalDeleteIsOpen}
        message='Tem certeza que deseja excluir esse item?'
        onConfirm={() => DeleteItem(ItemAtivo)}
        center
        onRequestClose={() => { setModalDeleteIsOpen(false); setItemAtivo(undefined) }}
      />}
      <ModalProgresso
        isOpen={ModalProgressoIsOpen}
        onRequestClose={() => setModalProgressoIsOpen(false)}
      />
      {BaixarRelatorio && Model && <PDFDownloadLink
        document={
          <RelatorioPDF
            model={Model}
            escala={EscalaRelatorio}
          />
        }
        id='botaoBaixarRelatorio'
      >
        {() =>
          <Box pos={'absolute'}></Box>
        }
      </PDFDownloadLink>}
      {BaixarRelatorioIndividual && ModelIndividual && <PDFDownloadLink
        document={
          <RelatorioIndividualPDF
            model={ModelIndividual}
          />
        }
        id='botaoBaixarRelatorioIndividual'
      >
        {() =>
          <Box pos={'absolute'}></Box>
        }
      </PDFDownloadLink>}
      <Flex gap={'1.75rem'}>
        <Flex flexDir={'column'} gap={'1.75rem'} w={'100%'}>
          <Flex gap={'1rem'}>
            <BoxQtd
              titulo='Número de relatórios'
              icon={<FaPeopleGroup size={30}/>}
              quantidade={Dash.totalRegistros}
            />
            <BoxQtd
              titulo='Número de relatórios disponíveis'
              icon={<BsCoin size={30}/>}
              quantidade={Dash.creditos}
            />
            <BoxQtd
              titulo='Número de cargos'
              icon={<MdOutlineBusinessCenter size={30}/>}
              quantidade={Dash.nomeCargoUnicos}
            />
          </Flex>
          {(Dash.aderentes.length > 0 || Dash.aderentesResalva.length > 0 || Dash.naoAderentes.length > 0) && <Flex position={'relative'} border={'1px solid var(--c6)'} alignItems={'center'} justifyContent={'center'} h={'15rem'} width={'100%'} boxShadow={'var(--SombraBackground)'} bg={'var(--c1)'} px={'1rem'} borderRadius={'.325rem'} gap={'.5rem'}>
            <Flex position={'absolute'} top={'.75rem'} right={'.75rem'} zIndex={1} bg={'var(--Gray6)'} borderRadius={'full'} p={'3px'} gap={'2px'}>
              {([3, 5] as const).map(escala => <Flex
                key={escala}
                as='button'
                px={'1rem'}
                py={'.25rem'}
                fontSize={'.75rem'}
                fontWeight={EscalaPizza === escala ? 'bold' : 'normal'}
                borderRadius={'full'}
                transition='all .2s'
                bg={EscalaPizza === escala ? 'white' : 'transparent'}
                color={EscalaPizza === escala ? 'var(--Azul)' : 'var(--Gray3)'}
                boxShadow={EscalaPizza === escala ? '0px 1px 3px rgba(0, 0, 0, 0.2)' : 'none'}
                _hover={{ color: 'var(--Azul)' }}
                onClick={() => setEscalaPizza(escala)}
              >{escala} níveis</Flex>)}
            </Flex>
            <Flex flexDir={'column'} gap={'.75rem'} w={'13rem'}>
              <Flex flexDir={'column'} gap={'.325rem'}>
                {(EscalaPizza === 3
                  ? [{ label: 'Aderentes', cor: 'var(--Green2)' }, { label: 'Aderentes com ressalvas', cor: 'var(--Yellow)' }, { label: 'Não aderentes', cor: 'var(--Red)' }]
                  : niveisPizza5.map(n => ({ label: n.label, cor: n.cor }))
                ).map(n => <Flex key={n.label} gap={'.325rem'} fontSize={'.875rem'} alignItems={'center'}>
                  <Flex borderRadius={'50%'} w={'.875rem'} h={'.875rem'} bg={n.cor}></Flex>
                  {n.label}
                </Flex>)}
              </Flex>
            </Flex>
            {EscalaPizza === 3
              ? <PieChart
                key={'pizza-3'}
                id={'pie-chart-aderentes-e-nao-aderentes-id'}
                labels={['Aderentes', 'Aderentes com ressalvas', 'Não aderentes']}
                colors={['#27AE60', '#FFBF2A', '#EB5757']}
                series={[Dash.aderentes.length, Dash.aderentesResalva.length, Dash.naoAderentes.length]}
                onChoiceAderencia={(tipoAderencia) => {
                  OnOpenModal(tipoAderencia === 0 ? 'Aderentes' : tipoAderencia === 1 ? 'Aderentes com ressalvas' : 'Não aderentes')
                  setCandidatos(tipoAderencia === 0 ? Dash.aderentes : tipoAderencia === 1 ? Dash.aderentesResalva : Dash.naoAderentes)
                }}/>
              : niveisPizza5.every(n => (Dash.porAderencia5?.[n.nivel]?.length ?? 0) === 0)
                ? <Flex w={'240px'} h={'240px'} alignItems={'center'} justifyContent={'center'} textAlign={'center'} fontSize={'.875rem'} color={'var(--Gray3)'}>Nenhum relatório classificado em 5 níveis</Flex>
                : <PieChart
                id={'pie-chart-aderencia-5-id'}
                labels={niveisPizza5.map(n => n.label)}
                colors={niveisPizza5.map(n => n.cor)}
                series={niveisPizza5.map(n => Dash.porAderencia5?.[n.nivel]?.length ?? 0)}
                onChoiceAderencia={(indice) => {
                  OnOpenModal(niveisPizza5[indice].label)
                  setCandidatos(Dash.porAderencia5?.[niveisPizza5[indice].nivel] ?? [])
                }}/>}
          </Flex>}
        </Flex>
        <BoxQtd
          titulo='Business partners com mais vagas'
          tabela={Dash.top10}
          onClick={(nomeBp) => { setCandidatos(Items.filter(it => it.nomeBP === nomeBp)); OnOpenModal('BP: ' + nomeBp) }}
        />
      </Flex>
      <Flex gap={'1rem'} mt={'1.5rem'}>
        {Dash.statusAssessments.filter(e => e.id === 1 || e.id === 2 || e.id === 3 || e.id === 4 || e.id === 9).map(e => {
          return <BoxQtd titulo={GetStatus(e.id)} quantidade={e.quantidade} onClick={() => { setCandidatos(Items.filter(it => it.status === e.id)); OnOpenModal(GetStatusTitulo(e.id)) }} color={'black'} small/>
        })}
      </Flex>
      {(PodeRevisar && PendentesRevisao > 0) && <Flex
        alignItems={'center'}
        gap={'.75rem'}
        mt={'1.75rem'}
        p={'.875rem 1.25rem'}
        border={'1px solid var(--Orange)'}
        borderRadius={'.325rem'}
        bg={'var(--OrangeOpacoBg)'}
        color={'var(--OrangeEscuro)'}
        cursor={'pointer'}
        _hover={{ bg: 'var(--OrangeOpacoBg-hover)' }}
        onClick={() => OnChangeFiltroStatus(StatusRevisaoAh.toString())}
      >
        <FaExclamationCircle size={20}/>
        <Text fontSize={'.875rem'} fontWeight={'500'}>
          {PendentesRevisao === 1
            ? 'Existe 1 relatório aguardando revisão para liberação ao RH. Clique para visualizar.'
            : `Existem ${PendentesRevisao} relatórios aguardando revisão para liberação ao RH. Clique para visualizar.`}
        </Text>
      </Flex>}
      <Flex justifyContent={'space-between'} margin='1.75rem 0rem'>
        <Flex flexDir={'column'}>
          <h1>Gestão de relatórios PRISMAH</h1>
        </Flex>
        <Flex gap={'.5rem'} justifyContent={'end'} alignItems={'center'}>
          <ButtonCmp
          VarColor='Rosa'
          onClick={() => { window.location.href = `${process.env.REACT_APP_URL_API}/api/SI/relatorioCSV/${tokenJwt}` }}>Relatório
          </ButtonCmp>
          <SelectCmp
            value={StatusFiltro}
            OnChange={OnChangeFiltroStatus}
            width={'14rem'}
          >
            <option value={''}>Todos os status</option>
            {GetStatusVisiveis(VerTodos).map(e => {
              return <option key={e.id} value={e.id}>{e.titulo}</option>
            })}
          </SelectCmp>
          <SearchCmp
            EnterAction={() => { }}
            OnChange={setSearchText}
            placeholder={'Buscar'}
          />
        </Flex>
      </Flex>

      <LoadingContainer linhas={18} loading={IsLoadingBody}>
          {Items?.length > 0 && <Paginador
            next={(e) => setPagina(e)}
            prev={(e) => setPagina(e)}
            paginaAtual={Pagina}
            qtdElementos={Total}
            tamanho={Tamanho}
            setTamanho={(e) => { setTamanho(e); setPagina(0) }}
            filtros={
              <Flex alignItems={'center'} gap={'.5rem'}>
                <Input
                  size='xs'
                  h={'1.975rem'}
                  fontSize={'.875rem'}
                  bg={'white'}
                  borderColor={'var(--Gray4)'}
                  w={'9rem'}
                  type='date'
                  value={DataInicioFiltro}
                  onChange={(e) => OnChangeFiltroData(e.target.value, DataFimFiltro)}
                />
                <Text fontSize={'.875rem'}>até</Text>
                <Input
                  size='xs'
                  h={'1.975rem'}
                  fontSize={'.875rem'}
                  bg={'white'}
                  borderColor={'var(--Gray4)'}
                  w={'9rem'}
                  type='date'
                  value={DataFimFiltro}
                  onChange={(e) => OnChangeFiltroData(DataInicioFiltro, e.target.value)}
                />
                {ExibirEmpresa && <SelectCmp
                  value={EmpresaFiltro}
                  OnChange={OnChangeFiltroEmpresa}
                  width={'12rem'}
                >
                  <option value={''}>Todas as empresas</option>
                  {Empresas.map(e => {
                    return <option key={e.empresaId} value={e.empresaId}>{e.nome}</option>
                  })}
                </SelectCmp>}
              </Flex>
            }
          >
            <TableContainer overflowX={'auto'}>
            <Table variant='simple' border={'1px solid var(--c5)'}>
              <Thead>
                <Tr>
                  {ExibirEmpresa && <Th style={{ textAlign: 'left', paddingLeft: '1.5rem' }}>Empresa</Th>}
                  <Th style={{ textAlign: 'left', paddingLeft: '1.5rem' }}>Candidato</Th>
                  <Th>Gestor</Th>
                  <Th>Vaga</Th>
                  <Th>Nome do BP</Th>
                  <Th>Informações</Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                {Items?.map(e => {
                  return (
                    <Tr key={e.id}>
                      {ExibirEmpresa && <Td style={{ textAlign: 'left', paddingLeft: '1.5rem' }}>
                        <StyledSpan style={{ justifyContent: 'start', maxWidth: '10rem' }}>
                          <Text className='textWrap' color={'Gray1'} maxW={'10rem'} wordBreak={'break-word'} fontSize={'12px'} fontWeight={'600'}>{e.nomeEmpresa ?? '-'}</Text>
                        </StyledSpan>
                      </Td>}
                      <Td style={{ textAlign: 'left', paddingLeft: '1.5rem', minWidth: '17rem' }}>
                        <Flex flexDir={'column'} lineHeight={'12px'}>
                          <StyledSpan style={{ justifyContent: 'start' }}>
                            <Text color={'Gray1'} fontSize={'12px'} fontWeight={'600'}>{e.nome}</Text>
                          </StyledSpan>
                          <StyledSpan style={{ justifyContent: 'start', maxWidth: '17rem' }}>
                            <Text color={'Gray1'} fontSize={'12px'} fontWeight={'400'}>{e.email}</Text>
                          </StyledSpan>
                          <StyledSpan style={{ justifyContent: 'start', maxWidth: '17rem' }}>
                            <Text color={'Highlight'} fontSize={'12px'} fontWeight={'bold'}>Versao:{e.versaoPrismah ?? ''}</Text>
                          </StyledSpan>
                        </Flex>
                      </Td>
                      <Td>
                        <StyledSpan style={{ maxWidth: '7rem', minWidth: '7rem' }}>
                          <Text className='textWrap' color={'Gray1'} maxW={'7rem'} wordBreak={'break-word'} fontSize={'12px'} fontWeight={'400'} textAlign={'center'}>{e.gestor}</Text>
                        </StyledSpan>
                      </Td>
                      <Td>
                        <StyledSpan>
                          <Text color={'Gray1'} wordBreak={'break-word'} fontSize={'12px'} fontWeight={'400'} textAlign={'center'} className='textWrap' maxW={'9rem'} minW={'9rem'}>{e.nomeCargo}</Text>
                        </StyledSpan>
                      </Td>
                      <Td>
                        <StyledSpan>
                          <Text color={'Gray1'} wordBreak={'break-word'} fontSize={'12px'} fontWeight={'400'} textAlign={'center'} className='textWrap' maxW={'9rem'} minW={'9rem'}>{e.nomeBP}</Text>
                        </StyledSpan>
                      </Td>
                      <Td>
                        <Flex flexDir={'column'} gap={'.125rem'} lineHeight={'14px'} maxW={'12rem'}>
                          <StyledSpan>
                            <Text color={'Gray1'} fontSize={'12px'} fontWeight={'400'}>Data de criação: <strong>{formatarData(e.dataCriacao ?? '')}</strong></Text>
                          </StyledSpan>
                          <StyledSpan>
                            <Text color={'Gray1'} fontSize={'12px'} fontWeight={'400'}>Data de alteração: <strong>{e.dataAlterado ? formatarData(e.dataAlterado) : '-'}</strong></Text>
                          </StyledSpan>
                          <StyledSpan>
                            <Text display={'flex'} gap={'.25rem'} color={'Gray1'} fontSize={'12px'} fontWeight={'400'}>Status: {GetStatus(e.status, VerTodos)}</Text>
                          </StyledSpan>
                        </Flex>
                      </Td>
                      <Td>
                        <StyledSpan style={{ gap: '.75rem' }}>
                          <Flex flexDir={'column'} gap={'.625rem'} alignItems='center' justifyContent={'center'} w={'full'}>
                            {(e.status !== 1 && e.status !== 2) && (Dash.tipoAcesso === 1 || AutorizarConsultorPrismah() || e.status !== 10) && (GetPermissaoBotoesClaro() || (e.status === 4)) && <Menu>
                              <MenuButtonCmp
                                    Icon={<FaChevronDown size={8} style={{ marginLeft: '-4px' }}/>}
                                    VarColor='Green2'
                                    width='8rem'
                                    small
                                >Opções
                              </MenuButtonCmp>
                                <MenuList bg={'white'} borderRadius={'.5rem'} boxShadow={'0px 2px 8px rgba(0, 0, 0, 0.25)'} border={'1px solid var(--c5)'}>
                                  {(Dash.tipoAcesso === 1 || AutorizarConsultorPrismah()) && e.status === 13 && <StyledMenuItem onClick={() => nav(`/PRISMAH/${e.id}/SelecionarPI`)}>
                                    Selecionar PI
                                  </StyledMenuItem>}
                                  {(Dash.tipoAcesso === 1 || AutorizarConsultorPrismah()) && e.status !== 13 && <StyledMenuItem onClick={() => nav(`/PRISMAH/${e.id}/Editar`)}>
                                    Editar relatório
                                  </StyledMenuItem>}
                                  {(e.urlpdfRelatorioIndividual && e.urlpdfRelatorioRH) && e.status !== 13 && IsLoading !== e.id && (((e.status === 3 || e.status === 10) && (token.adm === 'True' || token.cid === 'a5ee6794-41de-4163-983b-b3e66912b72e' || token.cid === 'eaa268cc-85c3-4fbc-96a5-349e33df27bf' || AutorizarConsultorPrismah())) || (e.status === 4)) && <>
                                    <StyledMenuItem onClick={() => OnGerarRelatorios(e.id, 3)}>
                                      Gerar relatório (escala 3)
                                    </StyledMenuItem>
                                    <StyledMenuItem onClick={() => OnGerarRelatorios(e.id, 5)}>
                                      Gerar relatório (escala 5)
                                    </StyledMenuItem>
                                  </>}
                                  {e.status !== 10 && GetPermissaoBotoesClaro() && <StyledMenuItem onClick={() => onChangeStatus(e.id, '3')}>
                                    Ocultar relatório
                                  </StyledMenuItem>}
                                  {e.status !== 10 && (e.urlpdfRelatorioIndividual && e.urlpdfRelatorioRH) && (GetPermissaoBotoesClaro()) && <StyledMenuItem onClick={() => onChangeStatus(e.id, '4')}>
                                    Liberar relatório
                                  </StyledMenuItem>}
                                  {e.status === 10 && (Dash.tipoAcesso === 1 || AutorizarConsultorPrismah()) && <StyledMenuItem onClick={() => onChangeStatus(e.id, '3')}>
                                    Liberar para o RH
                                  </StyledMenuItem>}
                                  {e.status !== 10 && (Dash.tipoAcesso === 1 || AutorizarConsultorPrismah()) && <StyledMenuItem onClick={() => onChangeStatus(e.id, '10')}>
                                    Ocultar para o RH
                                  </StyledMenuItem>}
                                  <StyledMenuItem onClick={() => { window.location.href = `${process.env.REACT_APP_URL_API}/api/SI/ExportarDadosCSV/${e.id}` }}>
                                    Baixar recomendações (CSV)
                                  </StyledMenuItem>
                                  {e.urlDescritivoCargo && <StyledMenuItem onClick={() => { window.location.href = e.urlDescritivoCargo }}>
                                    Baixar descritivo de cargo
                                  </StyledMenuItem>}
                                  {e.urlCurriculo && <StyledMenuItem onClick={() => { window.location.href = e.urlCurriculo }}>
                                    Baixar currículo
                                  </StyledMenuItem>}
                                  {e.urlpiCandidato && <StyledMenuItem onClick={() => { window.location.href = e.urlpiCandidato }}>
                                    Baixar PI do candidato
                                  </StyledMenuItem>}
                                  {e.urlpiDesenvolvimento && <StyledMenuItem onClick={() => { window.location.href = e.urlpiDesenvolvimento ?? '' }}>
                                    Baixar PI - Quadro de desenvolvimento
                                  </StyledMenuItem>}
                                  {e.urlpiGestor && <StyledMenuItem onClick={() => { window.location.href = e.urlpiGestor ?? '' }}>
                                    Baixar PI do gestor
                                  </StyledMenuItem>}
                                  {e.urlpiRelacionamentoGestor && <StyledMenuItem onClick={() => { window.location.href = e.urlpiRelacionamentoGestor ?? '' }}>
                                    Baixar PI - Relacionamento com gestor
                                  </StyledMenuItem>}
                                  {AutorizarReprocessarPrismah() && <StyledMenuItem onClick={() => ReprocessarIA(e.id)}>
                                    Reprocessar IA
                                  </StyledMenuItem>}
                                  {(Dash.tipoAcesso === 1 || AutorizarConsultorPrismah()) && <StyledMenuItem onClick={() => { setItemAtivo(e.id); setModalDeleteIsOpen(true) }}>
                                    Excluir item
                                  </StyledMenuItem>}
                                </MenuList>
                            </Menu>}
                            {(Dash.tipoAcesso === 1 || AutorizarConsultorPrismah() || e.status !== 10) && e.status !== 13 && (e.urlpdfRelatorioIndividual && e.urlpdfRelatorioRH) && <Menu onClose={() => {
                              setTimeout(() => {
                                OnClearRelatorios()
                              }, 2000)
                            }}>
                              <MenuButtonCmp
                                    LeftIcon={<FaFilePdf size={12} style={{ marginLeft: '-4px' }}/>}
                                    VarColor='Rosa'
                                    width='8rem'
                                    small
                                >Relatórios
                              </MenuButtonCmp>
                              {IsLoading !== e.id && <MenuList bg={'white'} borderRadius={'.5rem'} boxShadow={'0px 2px 8px rgba(0, 0, 0, 0.25)'} border={'1px solid var(--c5)'}>
                                {<StyledMenuItem onClick={() => {
                                  baixarRelatorio(e, e.urlpdfRelatorioRH ?? '', 'Assessment')
                                }}>
                                  <FaDownload style={{ marginRight: '.375rem' }} size={'14'}/>
                                  Relatório para o RH
                                </StyledMenuItem>}
                                {<StyledMenuItem onClick={() => {
                                  baixarRelatorio(e, e.urlpdfRelatorioRH ?? '', 'Assessment')
                                }}>
                                  <FaDownload style={{ marginRight: '.375rem' }} size={'14'}/>
                                  Relatório para o Gestor
                                </StyledMenuItem>}
                                {<StyledMenuItem onClick={() => {
                                  baixarRelatorio(e, e.urlpdfRelatorioIndividual ?? '', 'Individual')
                                }}>
                                  <FaDownload style={{ marginRight: '.375rem' }} size={'14'}/>
                                  Relatório individual
                                </StyledMenuItem>}
                              </MenuList>}
                              {IsLoading === e.id && <MenuList bg={'white'} borderRadius={'.5rem'} boxShadow={'0px 2px 8px rgba(0, 0, 0, 0.25)'} border={'1px solid var(--c5)'}>
                                <StyledMenuItem>
                                    <Spinner size={'sm'} mr={'.625rem'}/>
                                    Carregando relatórios...
                                  </StyledMenuItem>
                              </MenuList>}
                            </Menu>}
                            {(Dash.tipoAcesso === 1 || AutorizarConsultorPrismah() || e.status !== 10) && e.status !== 13 && !(e.urlpdfRelatorioIndividual && e.urlpdfRelatorioRH) && (((e.status === 3 || e.status === 10) && (token.adm === 'True' || token.cid === 'a5ee6794-41de-4163-983b-b3e66912b72e' || token.cid === 'eaa268cc-85c3-4fbc-96a5-349e33df27bf' || AutorizarConsultorPrismah())) || (e.status === 4)) && (IsLoading === e.id
                              ? <ButtonCmp h={'24px'} width='8rem' fontSize={'12px'} isLoading VarColor='Roxo'>Gerar relatórios</ButtonCmp>
                              : <Menu>
                                <MenuButtonCmp
                                  Icon={<FaChevronDown size={8} style={{ marginLeft: '-4px' }}/>}
                                  VarColor='Roxo'
                                  width='8rem'
                                  small
                                >Gerar relatórios
                                </MenuButtonCmp>
                                <MenuList bg={'white'} borderRadius={'.5rem'} boxShadow={'0px 2px 8px rgba(0, 0, 0, 0.25)'} border={'1px solid var(--c5)'}>
                                  <StyledMenuItem onClick={() => OnGerarRelatorios(e.id, 3)}>
                                    Escala 3
                                  </StyledMenuItem>
                                  <StyledMenuItem onClick={() => OnGerarRelatorios(e.id, 5)}>
                                    Escala 5
                                  </StyledMenuItem>
                                </MenuList>
                              </Menu>)}
                          </Flex>
                        </StyledSpan>
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            </Table>
          </TableContainer>
          </Paginador>}
      </LoadingContainer>

      {
        (Items?.length === 0 && !IsLoadingBody) && (
          <Flex py={'1rem'}>Não foram encontrados nenhum Assessment com estes parâmetros de busca</Flex>
        )
      }
    </Body>
  )
}
